module.exports = __webpack_public_path__ + "img/shop_4-8.001e5b97.jpg";